import { useInfiniteQuery } from '@tanstack/react-query';

export type QueryKey = 'loadByAppId' | 'getSupportedApps' | 'getStoresByAppId';

export type FetchDataProps = {
  appId: string;
  query?: string;
  page?: number;
};

export const useInfiniteQueryStoreFilterHook = (
  fetchDataProps: FetchDataProps,
  fetchData: (props: FetchDataProps) => Promise<any>,
  queryKey: QueryKey
) => {
  const { data, fetchNextPage, hasNextPage, isFetchingNextPage, isPending } = useInfiniteQuery({
    queryKey: [queryKey, fetchDataProps],
    queryFn: ({ pageParam }) => {
      const props = {
        ...fetchDataProps,
        page: pageParam,
      };
      return fetchData(props);
    },
    initialPageParam: 1,
    getNextPageParam: (lastPage, _allPages, lastPageParam) => {
      // If the last page is invalid, stop pagination
      if (!lastPage?.Data || !lastPage?.TotalRecordCount || !lastPage?.Limit) {
        return undefined;
      }

      // If we have fetched all remaining records, stop pagination
      const totalFetched = lastPage.Limit * lastPageParam;
      if (totalFetched >= lastPage.TotalRecordCount) {
        return undefined;
      }

      // Otherwise, fetch the next page
      return lastPageParam + 1;
    },
  });

  return {
    data,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
    isPending,
  };
};
